// /**
//  * Center - Add
//  */

// React
import React, { useState, useEffect } from 'react';
import windowSize from '../../../utils/hook/useWindowResize';

// react hook form
import { useForm } from 'react-hook-form';

// Client SDK
import Client from 'client-sdk/src/client';
import { GetAllUsersRequestBuilder } from 'client-sdk/src/users/users';

// UI
import {
  TextField,
  Grid,
  Button,
  CardHeader,
  CardContent,
  Card,
  Paper,
  Typography,
} from '@material-ui/core';

// Component
import MapPosition from './mapPosition';

// Type
import { Center, Supervisor } from '../interfaces';
import { User } from '../../users/interfaces';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import centersRepository from 'client-sdk/src/Repository/centers-repository';
import handleError from '../../../utils/handleError';
import handleNotfication from '../../../utils/handleNotfication';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {},
    item: {
      display: 'flex',
      alignItems: 'end',
      fontWeight: 500,
      width: '100%',
      '& > *': {
        // margin: theme.spacing(0, 0, 0, 1),
      },
    },
    icon: {
      color: '#8a8a8a',
      marginRight: theme.spacing(1),
    },
    text: {
      width: '100%',
    },
    errorText: {
      alignSelf: 'inherit',
      color: '#F30000',
      fontSize: '11px',
    },
    label: {
      display: 'flex',
      alignItems: 'center',
      fontSize: '14px',
      fontWeight: 400,
      color: '#8a8a8a',
      marginRight: '12px',
      marginTop: '21px',
    },
    typographyCards: {
      fontSize: '16px',
      color: 'white',
      backgroundColor: '#4BCF90',
      padding: '8px 24px 8px 50px',
      marginLeft: '-40px',
    },
    card: {
      marginBottom: '14px',
      overflow: 'visible',
      padding: '14px',
      paddingBottom: '0',
    },

    cardContent: {
      justifyContent: 'space-between',
      paddingLeft: '14px',
    },
    cardContentOrder: {
      paddingBottom: '10px',
    },
    headerBox: {
      marginLeft: '75px',
      display: 'flex',
      alignItems: 'center',
      marginBottom: '10px',
      marginTop: '10px',
    },
  })
);

type Props = {
  create: (body: Center, callback: () => void) => void;
  close: () => void;
  partnerId: number;
  supervisorsList: Supervisor[];
};

type Inputs = {
  name: string;
  code: string;
  admin: object;
  phoneNumber: number;
  province: string;
  city: string;
  zipCode: string;
  address: string;
};

function Add(props: Props) {
  const { register, handleSubmit, errors } = useForm<Inputs>({
    mode: 'onChange',
  });
  const [supervisorId, setSupervisorId] = useState(null as number | null);
  const [latLng, setLatLng] = useState({ lat: 0, lng: 0 } as {
    lat: number;
    lng: number;
  });
  const classes = useStyles();

  const [openAutocomplete, setOpenAutocomplete] = React.useState(false);
  const [options, setOptions] = React.useState<User[]>([]);
  const [isMob, setIsMob] = useState(false);
  const { width } = windowSize();
  const loading = openAutocomplete && options.length === 0;

  React.useEffect(() => {
    let active = true;
    if (!loading) {
      return undefined;
    }

    (async () => {
      const token = localStorage.getItem('token') || '';
      const makeRequest = new GetAllUsersRequestBuilder()
        .params({
          'role.equals': 'CENTER_ADMIN',
          'centersId.specified': false,
          size: 100,
        })
        .build();
      const client = new Client(token);
      const response = await client.execute(makeRequest);
      const users = response.data as any;
      if (active) {
        setOptions(users as User[]);
      }
      if (users.length === 0) {
      }
    })();

    return () => {
      active = false;
    };
  }, [loading]);

  React.useEffect(() => {
    if (!openAutocomplete) {
      setOptions([]);
    }
  }, [openAutocomplete]);

  useEffect(() => {
    if (width && width <= 480) {
      setIsMob(true);
    } else {
      setIsMob(false);
    }
  }, [width]);

  const onSubmit = async (data: any) => {
    const { partnerId } = props;
    const { name, phoneNumber, zipCode, address, city, province, code } = data;
    const { lat, lng } = latLng;
    try {
      await centersRepository.createCenter({
        payload: {
          body: {
            name: name.trim(),
            phoneNumber: phoneNumber.length > 0 ? phoneNumber : null,
            address,
            code,
            partnerId,
            city: city.trim(),
            province: province.trim(),
            zipCode,
            lat,
            lon: lng,
            supervisorId,
            status: 'ACTIVE',
          },
        }
      })
      handleNotfication("مرکز جدید با موفقیت ایجاد شد", "success")
    } catch (error) {
      handleError(error)
    }
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <Grid lg={12} md={12} container style={{ marginTop: '16px' }} spacing={4}>
        <Grid xs={12} item spacing={2}>
          <Grid md={12} lg={12} item>
            <Card
              className={classes.card}
              style={{ padding: '15px 0', marginTop: '-32px' }}
            >
              <CardHeader
                avatar={
                  <Grid>
                    <Typography
                      className={classes.typographyCards}
                      style={{ marginRight: '-25px' }}
                    >
                      اطلاعات مرکز
                    </Typography>
                  </Grid>
                }
              />

              <CardContent className={classes.cardContentOrder}>
                <Grid container lg={12} md={12} className={classes.cardContent}>
                  <Grid container item spacing={1} lg={9} md={9}>
                    <Grid container item xs={12} sm={4} md={4} lg={4}>
                      <div className={classes.item}>
                        <div style={{ width: '100%' }}>
                          <TextField
                            fullWidth
                            variant="outlined"
                            id="name"
                            name="name"
                            label="نام مرکز"
                            inputRef={register({
                              required: true,
                              minLength: 5,
                              maxLength: 25,
                            })}
                            error={errors.name && true}
                          />
                          {errors.name && errors.name.type === 'required' && (
                            <p className={classes.errorText}>
                              {'فیلد نام مرکز الزامیست'}
                            </p>
                          )}
                          {errors.name && errors.name.type === 'minLength' && (
                            <p className={classes.errorText}>
                              {'مقدار نام مرکز نباید کمتر از 5 کاراکتر باشد'}
                            </p>
                          )}
                          {errors.name && errors.name.type === 'maxLength' && (
                            <p className={classes.errorText}>
                              {'مقدار نام مرکز نباید بیشتر از 25 کاراکتر باشد'}
                            </p>
                          )}
                        </div>
                      </div>
                    </Grid>
                    <Grid container item xs={12} sm={4} md={4} lg={4}>
                      <div className={classes.item}>
                        <div style={{ width: '100%' }}>
                          <TextField
                            fullWidth
                            variant="outlined"
                            id="code"
                            name="code"
                            label="کد مرکز"
                            inputRef={register({
                              required: true,
                              minLength: 1,
                              maxLength: 50,
                            })}
                            error={errors.code && true}
                          />
                          {errors.code && errors.code.type === 'required' && (
                            <p className={classes.errorText}>
                              {'فیلد کد مرکز الزامیست'}
                            </p>
                          )}
                          {errors.code && errors.code.type === 'minLength' && (
                            <p className={classes.errorText}>
                              {'مقدار کد مرکز نباید کمتر از 1 کاراکتر باشد'}
                            </p>
                          )}
                          {errors.code && errors.code.type === 'maxLength' && (
                            <p className={classes.errorText}>
                              {'مقدار کد مرکز نباید بیشتر از 50 کاراکتر باشد'}
                            </p>
                          )}
                        </div>
                      </div>
                    </Grid>
                    <Grid container item xs={12} sm={4} md={4} lg={4}>
                      <div className={classes.item}>
                        <div style={{ width: '100%' }}>
                          <TextField
                            variant="outlined"
                            fullWidth
                            id="phoneNumber"
                            name="phoneNumber"
                            label="شماره تماس"
                            inputRef={register({
                              required: true,
                              minLength: 6,
                              maxLength: 15,
                              pattern: /^([+]+98|0)\d{5,10}$/g,
                            })}
                            error={errors.phoneNumber && true}
                          />
                          {errors.phoneNumber &&
                            errors.phoneNumber.type === 'required' && (
                              <p className={classes.errorText}>
                                {'فیلد شماره تماس الزامیست'}
                              </p>
                            )}
                          {errors.phoneNumber &&
                            errors.phoneNumber.type === 'pattern' && (
                              <p className={classes.errorText}>
                                {'فرمت فیلد شماره تماس صحیح نیست'}
                              </p>
                            )}
                          {errors.phoneNumber &&
                            errors.phoneNumber.type === 'minLength' && (
                              <p className={classes.errorText}>
                                {
                                  'مقدار شماره تماس نباید کمتر از 11 کاراکتر باشد'
                                }
                              </p>
                            )}
                          {errors.phoneNumber &&
                            errors.phoneNumber.type === 'maxLength' && (
                              <p className={classes.errorText}>
                                {
                                  'مقدار شماره تماس نباید بیشتر از 15 کاراکتر باشد'
                                }
                              </p>
                            )}
                        </div>
                      </div>
                    </Grid>
                    <Grid container item xs={12} sm={6} md={4} lg={4}>
                      <div className={classes.item}>
                        <div style={{ width: '100%' }}>
                          <TextField
                            variant="outlined"
                            fullWidth
                            id="city"
                            name="city"
                            label="شهر"
                            inputRef={register({
                              required: false,
                              minLength: 2,
                              maxLength: 20,
                            })}
                            error={errors.city && true}
                          />
                          {errors.city && errors.city.type === 'minLength' && (
                            <p className={classes.errorText}>
                              {'مقدار شهر نباید کمتر از 2 کاراکتر باشد'}
                            </p>
                          )}
                          {errors.city && errors.city.type === 'maxLength' && (
                            <p className={classes.errorText}>
                              {'مقدار شهر نباید بیشتر از 20 کاراکتر باشد'}
                            </p>
                          )}
                        </div>
                      </div>
                    </Grid>
                    <Grid container item xs={12} sm={6} md={4} lg={4}>
                      <div className={classes.item}>
                        <div style={{ width: '100%' }}>
                          <TextField
                            variant="outlined"
                            fullWidth
                            id="province"
                            name="province"
                            label="استان"
                            inputRef={register({
                              required: false,
                              minLength: 2,
                              maxLength: 20,
                            })}
                            error={errors.province && true}
                          />
                          {errors.province &&
                            errors.province.type === 'minLength' && (
                              <p className={classes.errorText}>
                                {'مقدار استان نباید کمتر از 2 کاراکتر باشد'}
                              </p>
                            )}
                          {errors.province &&
                            errors.province.type === 'maxLength' && (
                              <p className={classes.errorText}>
                                {'مقدار استان نباید بیشتر از 20 کاراکتر باشد'}
                              </p>
                            )}
                        </div>
                      </div>
                    </Grid>
                    <Grid container item xs={12} sm={6} md={4} lg={4}>
                      <div className={classes.item}>
                        <div style={{ width: '100%' }}>
                          <TextField
                            variant="outlined"
                            fullWidth
                            id="zipCode"
                            name="zipCode"
                            label="کد پستی"
                            inputRef={register({
                              required: true,
                              minLength: 10,
                              maxLength: 10,
                              pattern: /[0-9]/,
                            })}
                            error={errors.zipCode && true}
                          />
                          {errors.zipCode &&
                            errors.zipCode.type === 'required' && (
                              <p className={classes.errorText}>
                                {'فیلد کد پستی الزامیست'}
                              </p>
                            )}
                          {errors.zipCode &&
                            errors.zipCode.type === 'pattern' && (
                              <p className={classes.errorText}>
                                {'فرمت فیلد کد پستی صحیح نیست'}
                              </p>
                            )}
                          {errors.zipCode &&
                            errors.zipCode.type === 'minLength' && (
                              <p className={classes.errorText}>
                                {'مقدار کد پستی نباید کمتر از 10 کاراکتر باشد'}
                              </p>
                            )}
                          {errors.zipCode &&
                            errors.zipCode.type === 'maxLength' && (
                              <p className={classes.errorText}>
                                {'مقدار کد پستی نباید بیشتر از 10 کاراکتر باشد'}
                              </p>
                            )}
                          {errors.zipCode &&
                            errors.zipCode.type === 'pattern' && (
                              <p className={classes.errorText}>
                                {'کیبورد خود را انگلیسی کنید'}
                              </p>
                            )}
                        </div>
                      </div>
                    </Grid>
                    <Grid container item xs={12} sm={12} md={12} lg={12}>
                      <div className={classes.item}>
                        <div style={{ width: '100%' }}>
                          <TextField
                            variant="outlined"
                            fullWidth
                            id="address"
                            name="address"
                            label="آدرس"
                            inputRef={register({
                              required: true,
                              minLength: 10,
                              maxLength: 200,
                            })}
                            error={errors.address && true}
                          />
                          {errors.address &&
                            errors.address.type === 'required' && (
                              <p className={classes.errorText}>
                                {'فیلد آدرس الزامیست'}
                              </p>
                            )}
                          {errors.address &&
                            errors.address.type === 'minLength' && (
                              <p className={classes.errorText}>
                                {'مقدار آدرس نباید کمتر از 10 کاراکتر باشد'}
                              </p>
                            )}
                          {errors.address &&
                            errors.address.type === 'maxLength' && (
                              <p className={classes.errorText}>
                                {'مقدار آدرس نباید بیشتر از 200 کاراکتر باشد'}
                              </p>
                            )}
                        </div>
                      </div>
                    </Grid>
                  </Grid>
                  <Grid item container lg={3} md={3}>
                    <Grid
                      style={{ border: 'solid 2px gray' }}
                      container
                      item
                      xs={12}
                      lg={12}
                      md={12}
                    >
                      <div style={{ width: '100%' }}>
                        <MapPosition
                          style={{ height: '35vh' }}
                          zoom={14}
                          center={{ lat: 35.6892, lng: 51.389 }}
                          position={latLng}
                          setLatlng={(latLng: { lat: number; lng: number }) => {
                            setLatLng(latLng);
                          }}
                        />
                      </div>
                    </Grid>
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
        <Grid
          container
          lg={12}
          md={12}
          xs={12}
          spacing={2}
          style={{
            flexDirection: 'row-reverse',
            position: 'fixed',
            backgroundColor: '#D5DADD',
            bottom: '0',
            right: '75px',
            padding: '15px',
            zIndex: 2,
          }}
        >
          <Grid
            container
            style={{
              marginLeft: '35px',
              marginTop: '-4px',
            }}
          >
            <Button
              variant="outlined"
              color="primary"
              size="medium"
              onClick={() => window.history.back()}
              style={{
                marginRight: 'auto',
              }}
              data-cy="cancelBtn"
            >
              {'انصراف'}
            </Button>
            <Button
              type="submit"
              size="medium"
              data-cy="saveBtn"
              autoFocus
              variant="contained"
              color="primary"
              style={{
                marginRight: '14px',
                marginLeft: '120px',
              }}
            >
              ذخیره مرکز
            </Button>
          </Grid>
        </Grid>
      </Grid>
    </form>
  );
}

export default Add;
